<template>
  <div class="history_area">
    <div class="tab" :class="{active: mode == 0}" @click="change_page('buy-product-history')">Buying history</div>
    <div class="tab" :class="{active: mode == 1}" @click="change_page('buy-point-history')">Your gems history</div>
  </div>
</template>

<script>
export default {
  data: () => ({
    mode: 0,
  }),

  created() {
    this.mode = 0;
    if (window.location.href.indexOf('/buy-point-history') > 0) {
      this.mode = 1;
    }
  },

  methods: {
    change_page(page) {
      this.$router.push({ path: `/${page}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.history_area {
  display: flex;
  justify-content: space-between;
  max-width: 1000px;
  margin: auto;
  @media screen and  (max-width: $tabletWidth) {
    width: 96%;
  }
  .tab {
    width: 200px;
    text-align: center;
    padding: 20px 0;
    background-color: $white;
    color: $mainColor;
    font-size: 16px;
    font-weight: bold;
    border-top-left-radius: 36px;
    border-top-right-radius: 36px;
    cursor: pointer;
    &.active {
      background-color: rgba(8, 27, 64, 0.7);
      color: $white;
      cursor: default;
    }
    @media screen and  (max-width: $tabletWidth) {
      width: 120px;
      font-size: 12px;
      padding: 10px 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
}
</style>
